import styles from "./PromotionCardSlice.module.css";
import {
    generateStyleClasses,
    styleHelper,
} from "../../helpers/commonFunctions";
import useComponentsStore from "../../store/componentsStateStore";
import { useState } from "react";
import useHintStore from "../../store/hintStateStore";
import { logOrderProductsClickAddCart } from "../../membership/logging/helpers/commonLoggingFunctions";
import {PromotionCardSliceType} from "../../interfaces/promotionCardSlice/PromotionCardSlice.type";
import useAppStore from "../../store/AppStore";

export default function PromotionCardSlice({
                                                 item,
                                             }: {
    item: PromotionCardSliceType;
}) {
    const topPills = item?.topPills;
    const title = item?.title;
    const subtitleTextParts = title?.subtitleTextParts;
    const totalPrice = item?.totalPrice;
    const strikeThroughTotalPrice = item?.strikeThroughTotalPrice;
    const unitPrice = item?.unitPrice;
    const action = item?.actionRadio;
    const isChecked = item?.isChecked;
    const description = item?.description;
    const [isLoading, setIsLoading] = useState(false);
    const {
        continueDraft,
        isSelectingPayPerListing,
        setIsSelectingPayPerListing,
    } = useComponentsStore();
    const { setOpen } = useHintStore();

    const onClickHandler = async () => {
        if (isLoading || isSelectingPayPerListing) return;
        try {
            logOrderProductsClickAddCart();
            setIsSelectingPayPerListing(true);
            setIsLoading(true);
            await continueDraft(action.payload);
        } catch (err) {
            console.error(err);
        } finally {
            setIsSelectingPayPerListing(false);
            setIsLoading(false);
        }
    };

    return (
        <div className={`vas-d-flex pointerCursor vas-flex-column vas-align-items-center vas-w-100 vas-position-relative ${!isChecked ? styles.pixel_pad : ''}`}>
            {topPills && topPills.length > 0 && (
                <div className={`vas-d-flex vas-align-items-canter vas-position-absolute ${styles.consumer_tag_container}`}>
                    {topPills.map((topPill, idx) => {
                        return (
                            <div
                                key={idx}
                                className={`vas-px-2 vas-text-center vas-fw-bold vas-border-radius vas-text-14 ${styles.consumer_tag} ${generateStyleClasses(
                                    topPill?.style
                                )} ${!idx ? "vas-mx-2" : "vas-mx-1"}`}
                                style={styleHelper({
                                    color: topPill?.textColor ?? "",
                                    backgroundColor: topPill?.backgroundColor,
                                    border: topPill ? `1px solid ${topPill?.borderColor}` : "0px",
                                })}
                            >
                                {topPill?.text ?? ""}
                            </div>
                        );
                    })}
                </div>
            )}
            <div
                className={`vas-d-flex vas-flex-column vas-px-3 ${styles.py_35} vas-card vas-w-100 ${styles.bordered_card}`}
                style={styleHelper({
                    border: `${isChecked ? "2px" : "1px"} solid ${item.borderColor}`,
                })}
                onClick={onClickHandler}
            >
                <div className="vas-d-flex vas-justify-content-between">
                    <div className="vas-d-flex vas-gap-1 vas-align-items-start">
                        {isLoading ? (
                            <i className={`vas-spinner-border vas-text-success vas-spinner-border-sm vas-my-1 vas-mx-1 ${styles.loader_size}`}
                            />
                        ) : isChecked ? (
                            <input
                                type="radio"
                                className={`vas-mt-1 ${styles.icon_size}`}
                                checked={true}
                                readOnly={true}
                            />
                        ) : !isChecked ? (
                            <input
                                type="radio"
                                className={`vas-mt-1 ${styles.icon_size}`}
                                checked={false}
                                readOnly={true}
                            />
                        ) : (
                            <></>
                        )}
                        <div className="vas-d-flex vas-flex-column">
                          <span
                              className={`vas-text-18 ${generateStyleClasses(title.style)}`}
                              style={styleHelper({ color: title?.textColor })}
                          >
                            {title?.text}
                          </span>
                            {subtitleTextParts &&
                                subtitleTextParts?.length > 0 &&
                                subtitleTextParts?.map((headerSubTitle) => {
                                    return (
                                        <span
                                            key={headerSubTitle.text}
                                            className={`vas-text-12 ${generateStyleClasses(
                                                headerSubTitle.style
                                            )}`}
                                            style={styleHelper({ color: headerSubTitle.textColor })}
                                        >
                                            {headerSubTitle.text}
                                        </span>
                                    );
                                })}
                            {
                                description && <span
                                    className={`vas-text-12 ${generateStyleClasses(
                                        description.style
                                    )}`}
                                >
                                    {description.text}
                                </span>
                            }
                        </div>
                    </div>

                    <div className="vas-d-flex vas-flex-column vas-align-items-end">
                        {unitPrice && (
                            <span
                                className={`${generateStyleClasses(
                                    unitPrice?.style
                                )} vas-text-4`}
                                style={styleHelper({color: unitPrice?.textColor})}
                            >
                {unitPrice?.text}
              </span>
                        )}
                        <div className="vas-d-flex vas-align-items-center">
                            {strikeThroughTotalPrice && (
                                <span
                                    className={`${generateStyleClasses(
                                        strikeThroughTotalPrice?.style
                                    )} vas-text-decoration-line-through vas-text-13 vas-mx-1`}
                                    style={styleHelper({
                                        color: strikeThroughTotalPrice.textColor,
                                    })}
                                >
                  {strikeThroughTotalPrice?.text}
                </span>
                            )}
                            <span
                                className={`${generateStyleClasses(
                                    totalPrice?.style
                                )} vas-text-12`}
                                style={styleHelper({color: totalPrice?.textColor})}
                            >
                {totalPrice?.text}
              </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
